import React from 'react';
import styled from 'styled-components';

const CTAContainer = styled.div`
  background: linear-gradient(135deg, #6ed216 0%, #5cb012 100%);
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  margin: 30px 0;
  color: white;
`;

const CTATitle = styled.h3`
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: 600;
`;

const CTAText = styled.p`
  font-size: 16px;
  margin-bottom: 20px;
  opacity: 0.9;
`;

const CTAButton = styled.a`
  display: inline-block;
  background-color: white;
  color: #6ed216;
  padding: 12px 30px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  }
`;

function CallToAction({ calendarLink }) {
  if (!calendarLink) return null;

  return (
    <CTAContainer>
      <CTATitle>🚀 Prêt à optimiser vos prochaines campagnes ?</CTATitle>
      <CTAText>
        Nos experts vous accompagnent pour améliorer encore vos performances et maximiser votre ROI.
      </CTAText>
      <CTAButton href={calendarLink} target="_blank" rel="noopener noreferrer">
        📅 Prendre rendez-vous
      </CTAButton>
    </CTAContainer>
  );
}

export default CallToAction;